import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetBranchSelector({
  value,
  displayValue,
  branches,
  onChange,
  reloadDropdownData,
  viewOnly,
  size,
  showCloudIcon = true,
  showFormInputView = false,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={branches}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => {
          if (typeof reloadDropdownData === 'function') {
            reloadDropdownData()
          }
        }}
        placeHolder="Select Branch"
        showCloudIcon={showCloudIcon}
        size={size}
        showFormInputView={showFormInputView}
      />
    </React.Fragment>
  )
}
